"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _providerCard = _interopRequireDefault(require("./components/ProviderCard/provider-card"));
/* eslint-disable react/prop-types */
const ProviderTile = _ref => {
  let {
    provider,
    bookOnlineUrl,
    config,
    searchSummary,
    track,
    bookingCallback,
    reviewCallback,
    summaryCallback,
    apptInfo,
    onClickShowAvailability,
    availabilityTilesMessages,
    reviewUrl,
    summaryUrl,
    lazyLoadImg = true,
    shouldDisplayAvailability,
    availabilityLinkTarget,
    onTimeSlotsClick,
    onAvailabilityTilesLoaded,
    slots,
    slotsStatus,
    getLocationUrl,
    locationCallback,
    locationCTA
  } = _ref;
  /* 
    only display availability if:
      a) the health system is configured to display availability within PMC
      b) and this provider is bookable online
  */
  shouldDisplayAvailability = shouldDisplayAvailability && Boolean(provider.book_online_url);
  return /*#__PURE__*/_react.default.createElement(_providerCard.default, {
    provider: provider,
    bookOnlineUrl: bookOnlineUrl,
    config: config,
    searchSummary: searchSummary,
    track: track,
    bookingCallback: bookingCallback,
    reviewCallback: reviewCallback,
    reviewUrl: reviewUrl,
    summaryCallback: summaryCallback,
    apptInfo: apptInfo,
    onClickShowAvailability: onClickShowAvailability,
    availabilityTilesMessages: availabilityTilesMessages,
    summaryUrl: summaryUrl,
    lazyLoadImg: lazyLoadImg,
    shouldDisplayAvailability: shouldDisplayAvailability,
    availabilityLinkTarget: availabilityLinkTarget,
    onTimeSlotsClick: onTimeSlotsClick,
    onAvailabilityTilesLoaded: onAvailabilityTilesLoaded,
    slots: slots,
    slotsStatus: slotsStatus,
    getLocationUrl: getLocationUrl,
    locationCallback: locationCallback,
    locationCTA: locationCTA
  });
};
/* eslint-enable react/prop-types */
var _default = exports.default = ProviderTile;
ProviderTile.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderTile",
  "props": {
    "lazyLoadImg": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    }
  }
};